import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './rejection-reason.reducer';

export interface IRejectionReasonHFDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const RejectionReasonHFDetail = (props: IRejectionReasonHFDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { rejectionReasonHFEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          RejectionReasonHF [<b>{rejectionReasonHFEntity.id}</b>]
        </h2>

        <dl className="jh-entity-details">
          <dt>
            <span id="description">Incident Report (English)</span>
          </dt>
          <dd>{rejectionReasonHFEntity.enRejectionReason}</dd>
        </dl>

        <dl className="jh-entity-details">
          <dt>
            <span id="description">Incident Report (Local Language)</span>
          </dt>
          <dd>{rejectionReasonHFEntity.stRejectionReason}</dd>
        </dl>
        <dl className="jh-entity-details">
          <dt>
            <span id="description">Active</span>
          </dt>
          <dd>{rejectionReasonHFEntity.isActive ? 'Yes' : 'No'}</dd>
        </dl>
        <Button tag={Link} to="/rejection-reasons-hf" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/rejection-reasons-hf/${rejectionReasonHFEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ rejectionReasonHF }: IRootState) => ({
  rejectionReasonHFEntity: rejectionReasonHF.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RejectionReasonHFDetail);
